import { createMergeReducer } from '../utils/reducer'

type Features = 'useMFA' | 'useFaq' | 'useContactUs' | 'usePlayer' | 'isElcano' |
  'useEpisodeListSortingT1' | 'useEpisodeListSortingT2' | 'useNodeGiftCard' | 'useNewHover' |
  'useNodeDeeplinking'

export type FeatureToStatus = { [feature in Features]?: boolean } & AtfTreatmentProps
export const reducer = createMergeReducer(
  t => t.features,
  {} as FeatureToStatus
)

export interface AtfTreatmentProps {
  atfTreatment?: AtfTreatment
}
export type AtfTreatment = 'C' | 'T1' | 'T2' | 'T3'
